import { List, Typography, Pagination, Avatar, Tag, Switch, Input, message } from 'antd';
import { useProductsList } from 'hooks/api';
import { EditFilled, CopyOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useRef, useState } from 'react';
import APP_ROUTES from 'config/routes';
import { usePagination } from 'hooks/common';

import { Link } from 'react-router-dom';
import styles from './index.module.scss';

const { Text } = Typography;

const PAGE_SIZE = 20;

const ProductList = () => {
  const { page, setPage } = usePagination(1);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return undefined;
    }
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 400);
    return () => clearTimeout(timer);
  }, [search]);

  const { data, isLoading } = useProductsList({
    skip: (page - 1) * PAGE_SIZE,
    limit: PAGE_SIZE,
    name: debouncedSearch || undefined,
  });

  const renderItem = useCallback((item: Product.Item, idx) => {
    const descriptionRender = (
      <div className={styles.description}>
        <div className={styles.store}>
          {item.store.map((s, storeIndex) => (
            <div key={storeIndex.toString()}>
              <Switch defaultChecked />
              <span className={styles.name}>{s}</span>
            </div>
          ))}
        </div>
        <div>
          {item.values[0]?.display && (
            <Tag
              className={styles.displayTag}
              icon={<CopyOutlined />}
              onClick={() => {
                navigator.clipboard.writeText(item.values[0].display);
                message.success('Скопировано!');
              }}
            >
              {item.values[0].display}
            </Tag>
          )}
          {item.values.map((i, valueIdx) => (
            <span key={valueIdx.toString()}>
              <Tag className={styles.tag}>
                $
                {' '}
                {i.price / 100}
              </Tag>
              {i.outOfStock && (
                <Tag color='red'>Out of stock</Tag>
              )}
            </span>
          ))}
        </div>
      </div>
    );

    const titleRender = (
      <div>
        {item.name}
        <span>
          {item.providers.map((i, providerIdx) => (
            <span key={providerIdx.toString()} className={styles.title}>
              (
              {i.name}
              {item.providers.length - 1 === idx ? null : ','}
              {' '}
              )
            </span>
          ))}
        </span>
        <Link
          aria-label='edit'
          className={styles.edit}
          to={APP_ROUTES.PRODUCT_EDIT.replace(':id', item._id)}
        >
          <EditFilled />
        </Link>
        {/* <a */}
        {/*  aria-label='edit' */}
        {/*  className={styles.edit} */}
        {/*  href={APP_ROUTES.PRODUCT_EDIT.replace(':id', item._id)} */}
        {/* > */}
        {/*  <EditFilled /> */}
        {/* </a> */}
      </div>
    );

    return (
      <List.Item className={styles.list} key={idx.toString()}>
        <List.Item.Meta
          avatar={<Avatar src={item.image} />}
          title={titleRender}
          description={descriptionRender}
        />
      </List.Item>
    );
  }, []);

  return (
    <div>
      <Text type='secondary'>Product list</Text>
      <Input.Search
        placeholder='Search by name...'
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        allowClear
        style={{ marginBottom: 16, marginTop: 8 }}
      />
      <List
        className={styles.listWrapper}
        itemLayout='vertical'
        size='large'
        dataSource={data?.data}
        renderItem={renderItem}
        loading={isLoading}
      />
      <Pagination
        className={styles.pagination}
        current={page}
        defaultCurrent={page}
        total={data?.total || 0}
        pageSize={PAGE_SIZE}
        onChange={(p: number) => setPage(p)}
        showSizeChanger={false}
      />
    </div>
  );
};

export default ProductList;
